import { render } from "./PortCarousel.vue?vue&type=template&id=82173954&scoped=true"
import script from "./PortCarousel.vue?vue&type=script&lang=js"
export * from "./PortCarousel.vue?vue&type=script&lang=js"

import "./PortCarousel.vue?vue&type=style&index=0&id=82173954&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82173954"]])

export default __exports__